<template>
  <v-row justify="center" fluid>
    <v-col cols="12">
      <OnexAlert class="mb-4" :type="Notifications.error" dismissible="false">
        {{ $t('L_payment_change_alert_warning') }}
      </OnexAlert>
    </v-col>
    <v-col cols="12" sm="10" md="7">
      <v-card flat>
        <v-card-text>
          <h2 role="heading" aria-level="3" class="text-h2 text-center font-weight-regular">
            {{ $t('L_payment_change_alert_heading') }}
          </h2>
          <p class="my-4 text-center">{{ $t('L_payment_change_alert_desc') }}</p>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center">
            <v-col>
              <OnexButton
                id="alert_change_payment_btn_cancel"
                variant="outlined"
                block
                color="primary"
                @click="cancel"
              >
                <h3 class="heading_three font-weight-medium font-size-md">
                  {{ $t('L_cancel') }}
                </h3>
              </OnexButton>
            </v-col>
            <v-col>
              <OnexButton
                id="alert_change_payment_btn_continue"
                variant="elevated"
                block
                color="primary"
                @click="goToStepOne"
              >
                <h3 class="heading_three font-weight-medium font-size-md">
                  {{ $t('L_payment_change_alert_change') }}
                </h3>
              </OnexButton>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexAlert, OnexButton, Notifications } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'AlertChangePayment',
  components: {
    OnexButton,
    OnexAlert,
  },
  data: () => ({
    Notifications,
  }),
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    goToStepOne() {
      this.$emit('disablePaymentDetailsLink');
      this.$emit('goToStepOne');
    },
  },
};

export default defineComponent(componentOptions);
</script>
